// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FlexTextarea {
  position: relative;
  width: 100%;
  height: 180px;
}
.FlexTextarea textarea,
.FlexTextarea .textarea_html {
  overflow: hidden;
  box-sizing: border-box;
  padding: 0 8px 0 8px;
  background-color: var(--white-color-lightest);
  width: 100%;
  height: 100%;
  resize: none;
}
.FlexTextarea textarea {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  color: var(--dark-color-dark);
  background-color: var(--input-bg-color);
  background-clip: padding-box;
  border: 1px solid var(--border-color);
  appearance: none;
  border-radius: 4px;
  transition: all 0.15s;
  padding: 12px;
  line-height: 12px;
  font-family: inherit;
}
.FlexTextarea textarea::placeholder {
  color: #c2c8d2;
  opacity: 1;
}
.FlexTextarea textarea:focus {
  background-color: var(--input-bg-color);
  border: 1px solid var(--primary-color-main);
  outline: 0;
}
.FlexTextarea textarea:disabled {
  background: var(--disabled-bg-color);
  color: var(--disabled-font-color);
  cursor: default;
  -webkit-appearance: none;
  border: 1px solid var(--disabled-border-color);
}
.FlexTextarea .textarea_html {
  min-height: 180px;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  color: var(--font_active_color);
}
.FlexTextarea .textarea_html .placeholder {
  color: var(--font_inactive_color);
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/UI/Textarea.scss"],"names":[],"mappings":"AAAA;EACC,kBAAA;EACA,WAAA;EACA,aAAA;AACD;AACC;;EAEC,gBAAA;EACA,sBAAA;EACA,oBAAA;EACA,6CAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AACF;AACC;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,cAAA;EACA,6BAAA;EACA,uCAAA;EACA,4BAAA;EACA,qCAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EAEA,aAAA;EACA,iBAAA;EAEA,oBAAA;AADF;AAGE;EACE,cAAA;EACA,UAAA;AADJ;AAIE;EACC,uCAAA;EACA,2CAAA;EACA,UAAA;AAFH;AAKE;EACC,oCAAA;EACA,iCAAA;EACA,eAAA;EACA,wBAAA;EACA,8CAAA;AAHH;AAQC;EACC,iBAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,+BAAA;AANF;AAOE;EACC,iCAAA;AALH","sourcesContent":[".FlexTextarea {\r\n\tposition: relative;\r\n\twidth: 100%;\r\n\theight: 180px;\r\n\r\n\ttextarea,\r\n\t.textarea_html {\r\n\t\toverflow: hidden;\r\n\t\tbox-sizing: border-box;\r\n\t\tpadding: 0 8px 0 8px;\r\n\t\tbackground-color: var(--white-color-lightest);\r\n\t\twidth: 100%;\r\n\t\theight: 100%;\r\n\t\tresize: none;\r\n\t}\r\n\ttextarea {\r\n\t\tposition: absolute;\r\n\t\ttop: 0;\r\n\t\tleft: 0;\r\n\t\tdisplay: block;\r\n\t\tcolor: var(--dark-color-dark);\r\n\t\tbackground-color: var(--input-bg-color);\r\n\t\tbackground-clip: padding-box;\r\n\t\tborder: 1px solid var(--border-color);\r\n\t\tappearance: none;\r\n\t\tborder-radius: 4px;\r\n\t\ttransition: all 0.15s;\r\n\t\t\r\n\t\tpadding: 12px;\r\n\t\tline-height: 12px;\r\n\r\n\t\tfont-family: inherit;\r\n\r\n\t\t&::placeholder {\r\n\t\t\t\tcolor: #c2c8d2;\r\n\t\t\t\topacity: 1;\r\n\t\t\t}\r\n\t\t\r\n\t\t&:focus {\r\n\t\t\tbackground-color: var(--input-bg-color);\r\n\t\t\tborder: 1px solid var(--primary-color-main);\r\n\t\t\toutline: 0;\r\n\t\t}\r\n\t\r\n\t\t&:disabled {\r\n\t\t\tbackground: var(--disabled-bg-color);\r\n\t\t\tcolor: var(--disabled-font-color);\r\n\t\t\tcursor: default;\r\n\t\t\t-webkit-appearance: none;\r\n\t\t\tborder: 1px solid var(--disabled-border-color);\r\n\t\t}\r\n\t}\r\n\r\n\r\n\t.textarea_html {\r\n\t\tmin-height: 180px;\r\n\t\twhite-space: pre-wrap;\r\n\t\tword-wrap: break-word;\r\n\t\toverflow-wrap: break-word;\r\n\t\tcolor: var(--font_active_color);\r\n\t\t.placeholder {\r\n\t\t\tcolor: var(--font_inactive_color);\r\n\t\t}\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
